<template>
  <v-list class="pa-3 mb-3 elevation-5">
    <v-list-tile class="list-tile-auto-height">
      <v-list-tile-avatar>
        <v-icon
          x-large
          color="msr"
        >
          hourglass_bottom
        </v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-sub-title>
          {{ bookingRequest.requested_at | dayjs('DD.MM.YYYY') }}
        </v-list-tile-sub-title>
        <v-list-tile-title class="title">
          {{ title }}
        </v-list-tile-title>
        <div class="mt-2 body-1">
          {{ hint }}
        </div>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  props: {
    bookingRequest: {
      type: Object,
      required: true,
    },
  },
  computed: {
    title() {
      if (
        this.$store.getters.userIsBeingManaged &&
        !this.$store.getters.isManagedCoadmin
      ) {
        return this.$t('contentCreatorBookingRequestActiveManagedTitle');
      }
      return this.$t('contentCreatorBookingRequestActiveAdminTitle');
    },
    hint() {
      if (
        this.$store.getters.userIsBeingManaged &&
        !this.$store.getters.isManagedCoadmin
      ) {
        return this.$t('contentCreatorBookingRequestActiveManagedHint');
      }
      return this.$t('contentCreatorBookingRequestActiveAdminHint');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ContentCreatorActiveBookingRequestHint.vue